import { useState } from 'react';

// Helper function to subscribe to Mailchimp via JSONP
const subscribeToMailchimp = (email, fname, lname) => {
  return new Promise((resolve, reject) => {
    const url = `https://gonzalezinfo.us6.list-manage.com/subscribe/post?u=${import.meta.env.VITE_MAILCHIMP_U}&id=${import.meta.env.VITE_MAILCHIMP_ID}&EMAIL=${encodeURIComponent(email)}&MERGE1=${encodeURIComponent(fname)}&MERGE2=${encodeURIComponent(lname)}`;

    const callbackName = `mailchimpCallback_${Date.now()}`;

    window[callbackName] = (data) => {
      delete window[callbackName];
      document.body.removeChild(script);
      if (data.result === 'success') {
        resolve(data);
      } else {
        reject(new Error(data.msg || 'Subscription failed'));
      }
    };

    const script = document.createElement('script');
    script.src = `${url}&c=${callbackName}`;
    script.onerror = () => {
      delete window[callbackName];
      document.body.removeChild(script);
      reject(new Error('Failed to load Mailchimp script'));
    };
    document.body.appendChild(script);
  });
};

export default function NewsletterForm({ open }) {
  const [email, setEmail] = useState('');
  const [fname, setFname] = useState('');
  const [lname, setLname] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | success | error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setMessage('');

    try {
      const data = await subscribeToMailchimp(email, fname, lname);
      setStatus('success');
      setMessage(data.msg || 'Thank you for subscribing!');
      setEmail('');
      setFname('');
      setLname('');
    } catch (error) {
      setStatus('error');
      setMessage(error.message || 'Subscription failed. Please try again.');
    }
  };

  return (
    <div
      className="footer-newsletter-inner"
      style={{
        right: open ? '0' : '-999px',
        opacity: open ? '1' : '0',
        pointerEvents: open ? 'auto' : 'none',
      }}
    >
      <div className="flex just-center">
        <h3 className="white">{status === 'success' ? 'Success!' : ''}</h3>
      </div>

      {status === 'sending' && (
        <div className="flex just-center white">
          <p>sending...</p>
        </div>
      )}

      {status === 'error' && (
        <div className="flex just-center white" dangerouslySetInnerHTML={{ __html: message }} />
      )}

      {status === 'success' && (
        <div className="flex just-center white" dangerouslySetInnerHTML={{ __html: message }} />
      )}

      {status !== 'success' && (
        <form className="footer-form" onSubmit={handleSubmit}>
          <div className="footer-form-inputs">
            <input
              type="text"
              placeholder="First Name"
              name="fname"
              className="footer-input first-name"
              value={fname}
              onChange={(e) => setFname(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Last Name"
              name="lname"
              className="footer-input last-name"
              value={lname}
              onChange={(e) => setLname(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Email"
              name="email"
              className="footer-input email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="flex">
            <button type="submit" disabled={status === 'sending'}>
              {status === 'sending' ? 'Joining...' : 'Join'}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
